import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

function Section({ title, body }) {
  return (
    <section className="zx-legal__section">
      <h2>{title}</h2>
      <p>{body}</p>
    </section>
  );
}

export default function CookiePolicy() {
  const { t } = useI18n();
  return (
    <article className="zx-legal">
      <header className="zx-legal__head">
        <h1>{t("cookiePolicy.title")}</h1>
        <p className="zx-legal__updated">{t("cookiePolicy.updated")}</p>
        <p className="zx-legal__lead">{t("cookiePolicy.lead")}</p>
      </header>
      {[1,2,3,4,5,6].map((n) => (
        <Section key={n} title={t(`cookiePolicy.s${n}Title`)} body={t(`cookiePolicy.s${n}Body`)} />
      ))}
    </article>
  );
}
